import React from 'react';

import './List.css';

interface Props {
  children: React.ReactElement | null;
  additionalClasses?: string;
}

const List: React.FC<Props> = props => {
  const { children, additionalClasses } = props;

  return <ul className={`ui-widget-list ${additionalClasses}`}>{children}</ul>;
};

export default List;
